import React from 'react'

import ContentWithLoader from 'components/loaders/ContentWithLoader/ContentWithLoader'
import ModalContainer from 'components/_new/modal/ModalContainer/ModalContainer'
import Modal from 'components/_new/modal/Modal/Modal'
import Overlay from 'components/_new/layout/Overlay/Overlay'
import Text from 'components/_new/typography/Text/Text'

import Buttons from '../Buttons/Buttons'
import HintForPremium from '../HintForPremium/HintForPremium'
import ProductImagesWithName from '../ProductImagesWithName/ProductImagesWithName'

import s from './ExceptMobile.scss'
import messages from '../messages'


const SkincareProductDetailsModalExceptMobile = (props) => {
  const {
    texts: { description }, img, productId, brand, name, upchargePrice, media,
    onTryButtonClick, onAllProductsButtonClick, close, isFetching, withAddToQueueButton, isAllProductsButtonVisible,
  } = props

  return (
    <ModalContainer>
      <Overlay onClick={close} />
      <Modal className={s.modal} onClose={close}>
        <ContentWithLoader isFetching={isFetching}>
          <div className={s.content}>
            <div>
              <ProductImagesWithName {...{ img, productId, brand, name, upchargePrice, media }} />
              <Buttons {...{ onTryButtonClick, onAllProductsButtonClick, withAddToQueueButton, isAllProductsButtonVisible }} />
            </div>
            <div className={s.right}>
              {
                Boolean(upchargePrice) && (
                  <HintForPremium />
                )
              }
              <Text message={messages.about} size="16-24" semibold />
              <Text message={description} muted html />
            </div>
          </div>
        </ContentWithLoader>
      </Modal>
    </ModalContainer>
  )
}

SkincareProductDetailsModalExceptMobile.defaultProps = {
  texts: {},
}


export default SkincareProductDetailsModalExceptMobile
